export const ActionTypes = {
  GET_ENHANCED_SPECIALS_REQUEST: '[ENHANCED SPECIALS] GET ENHANCED SPECIALS REQUEST',
  GET_ENHANCED_SPECIALS_SUCCESS: '[ENHANCED SPECIALS] GET ENHANCED SPECIALS SUCCESS',
  GET_ENHANCED_SPECIALS_FAILURE: '[ENHANCED SPECIALS] GET ENHANCED SPECIALS FAILURE',
};

export class Actions {
  static getEnhancedSpecialsRequest() {
    return {
      type: ActionTypes.GET_ENHANCED_SPECIALS_REQUEST
    };
  }

  static getEnhancedSpecialsSuccess(eventIds) {
    return {
      type: ActionTypes.GET_ENHANCED_SPECIALS_SUCCESS,
      eventIds: eventIds
    };
  }

  static getEnhancedSpecialsFailure() {
    return {
      type: ActionTypes.GET_ENHANCED_SPECIALS_FAILURE
    };
  }

}
